const MONTH_MAP = [
  { header: "JAN", key: "jan" },
  { header: "FEB", key: "feb" },
  { header: "MAR", key: "mar" },
  { header: "APR", key: "apr" },
  { header: "MEI", key: "may" }, 
  { header: "JUN", key: "jun" },
  { header: "JUL", key: "jul" },
  { header: "AGU", key: "aug" },
  { header: "SEP", key: "sep" },
  { header: "OKT", key: "oct" },
  { header: "NOP", key: "nov" },
  { header: "DES", key: "dec" },
];


export const getTableConfig = (year) => {
  return [
    {
      name: "namaCabang",
      label: "CABANG",
      options: {
        sort: false,
        setCellHeaderProps: () => ({
          // style: {
          //   visibility: "hidden",
          //   height: 0,
          //   padding: 0,
          // },
        }),
      },
    },
    ...MONTH_MAP.map((m) => ({
      name: "",
      label: m.header, 
      options: {
        sort: false,
      },
    })),
    {
      name: "",
      label: `YTD ${year ?? ""}`,
      options: {
        sort: false,
      },
    },
  ];
};

export const mapSalesAbilityYTDToTable = (data = []) => {
  return data.map((item) => [
    item.namaCabang,
    ...MONTH_MAP.map((m) => Number(item[m.key] || 0)),
    Number(item.totalYear || 0),
  ]);
};

const MONTH_HEADERS = [
  { key: "jan", label: "JANUARI" },
  { key: "feb", label: "FEBRUARI" },
  { key: "mar", label: "MARET" },
  { key: "apr", label: "APRIL" },
  { key: "may", label: "MEI" },
  { key: "jun", label: "JUNI" },
  { key: "jul", label: "JULI" },
  { key: "aug", label: "AGUSTUS" },
  { key: "sep", label: "SEPTEMBER" },
  { key: "oct", label: "OKTOBER" },
  { key: "nov", label: "NOVEMBER" },
  { key: "dec", label: "DESEMBER" },
];

export const buildExcelRequestBodySalesAbilityYTD = ({ year, dataTable = [] }) => {
  const yearValue = year?.value || year;
  const filename = `${yearValue}_Laporan_Sales_Ability_YTD`;

  const sheets = [];

  if (Array.isArray(dataTable) && dataTable.length > 0) {
    sheets.push({
      name: `Laporan Sales Ability YTD ${yearValue}`,
      headers: [
        "No",
        "Cabang",
        ...MONTH_HEADERS.map((m) => m.label),
        `YTD ${yearValue}`,
      ],
      data: dataTable.map((rowData, rowIndex) => {
        const row = {
          No: rowIndex + 1,
          Cabang: rowData[0], 
        };

        MONTH_HEADERS.forEach((month, i) => {
          row[month.label] = rowData[i + 1] ?? 0;
        });

        row[`YTD ${yearValue}`] = rowData[rowData.length - 1] ?? 0;

        return row;
      }),
    });
  }

  return {
    filename,
    sheets,
  };
};